import { React } from 'mondrian-react';
import DefaultLayout from '../_layouts/default';
import TabTabelas from './components/TabTabelas';
import TabApis from './components/TabApis';
import styles from './styles.module.css';
const { useEffect, useState } = React;

function Tab() {
  const [result, setResult] = useState({});

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('@Claro-Catalogo:result'));

    setResult(data);

    return () => {
      setResult({});
    };
  }, []);

  return (
    <DefaultLayout>
      <div className={`mdn-Container ${styles.Container}`}>
        {result?._index === 'tabelas' ? (
          <TabTabelas result={result} />
        ) : (
          <TabApis result={result} />
        )}
      </div>
    </DefaultLayout>
  );
}

export default Tab;
